<template>
  <div class="event-card">
    <a :href="event.url" :tabindex="-1"><img :src="event.bannerImage" :alt="event.bannerAlt"/></a>
    <span class="overline">{{ event.subType ? event.subType : event.type }}</span>
    <h2 class="heading-2"><a :href="event.url">{{ event.title }}</a></h2>
    <p>
      <span v-if="event.type === 'Event'">
        {{ startDate.format('MMM D, YYYY') }} {{ startDate.format('h:mm A') }} - {{ endDate.format('h:mm A') }}
      </span>
      <span v-else>
        {{ startDate.format(startDateFormat)}} - {{ endDate.format('MMM D, YYYY') }}
      </span>
      at <a class="element-place" :data-id="event.location.locationId" :href="event.location.locationUrl">{{ event.location.locationName }}</a>
    </p>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'EventDetails',
  props: {
    event: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    dateFormat: 'MMM D, YYYY h:mm A'
  }),
  computed: {
    startDate () {
      return moment(this.event.startDate, this.dateFormat)
    },
    endDate () {
      return moment(this.event.endDate, this.dateFormat)
    },
    startDateFormat () {
      return ((this.startDate.format('YYYY') === this.endDate.format('YYYY'))) ? 'MMM D' : 'MMM D, YYYY'
    }
  }
}
</script>
